import React from 'react'

import UpdateCompanyAccount from '../../../containers/Admin/UpdateCompanyAccount'
import useSaveUserActivityLog from 'hooks/useSaveUserActivityLog'
import useFeatureToggle from 'hooks/useFeatureToggle'
import usePermission from 'hooks/usePermission'
import constants from 'config/constants'

export const Account = () => {
  const saveUserActivityLog = useSaveUserActivityLog()
  const { enableWorkspaceWeekStart, enableBenchmarks } = useFeatureToggle()
  const { hasPermission } = usePermission()
  const hasManageAccountSettingsPermission = hasPermission(
    constants.permissions.manageAccountSettings
  )

  return (
    <React.Fragment>
      <UpdateCompanyAccount
        hasManageAccountSettingsPermission={hasManageAccountSettingsPermission}
        saveUserActivityLog={saveUserActivityLog}
        enableWorkspaceWeekStart={enableWorkspaceWeekStart}
        enableBenchmarks={enableBenchmarks}
      />
    </React.Fragment>
  )
}

export default Account



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/Admin/Account/index.js